import * as yup from "yup";

export const ForgotSchema = (t) =>
  yup.object().shape({
    forgotEmail: yup.string().required(t.rules.email.required).email(t.rules.email.invalid)
  });
